import {AttributeDescriptor, BaseModel, BaseModelDescriptor} from "./BaseModel";
import {Upload} from "./Upload";
import {FormatTypes} from "../core/Formater";
import {ValidationTypes} from "../core/Validator";
import {Invoice} from "./Invoice";

export class Payment extends BaseModel {

	id: string
	price: string
	description: string
	paymentDate: string
    customerId: string
    invoiceId: string
	uploads: Upload[]
	date: string
	invoice?: Invoice
}

export class PaymentDescriptor extends BaseModelDescriptor{
	static id: AttributeDescriptor = {validation: []}
	static description: AttributeDescriptor = {validation: []}
	static date: AttributeDescriptor = {validation: []}
    static customerId: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
    static invoiceId: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static paymentDate: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED], format: FormatTypes.DATE}
	static price: AttributeDescriptor = {validation:[ValidationTypes.REQUIRED], format: FormatTypes.PRICE}
}
